// tslint:disable-next-line:no-implicit-dependencies
import type { IAugmentedJQuery, IController, IHttpService, IScope } from "angular";
import type { IEvent } from "App/Modules/Models";
import type { IConfig } from "App/Modules/Utils";
import type { SubscriptionLike as ISubscription } from "rxjs";
import { timer as observableTimer } from "rxjs";
import placeholder from "!svg-inline-loader!./Icons/image_placeholder.svg";

export default class HttpSrcDirectiveController implements IController {
    public static $inject = ["$http", "irConfig", "$scope", "$element"];

    public irHttpSrc: IEvent;

    public animatonFrame: number;

    public animatonPosition: number;

    public timer: ISubscription;

    public totalFrames: number;

    private styleText: string;

    private styleOffset: string;

    constructor(
        private $http: IHttpService,
        private config: IConfig,
        private $scope: IScope,
        private $element: IAugmentedJQuery,
    ) {}

    public $onInit() {
        this.init();
        this.totalFrames = this.irHttpSrc.image.thumbnail.spritesCount;

        this.timer = observableTimer(500, 150).subscribe(() => {
            this.animatonFrame += 1;
            if (this.animatonFrame >= this.totalFrames) {
                this.animatonFrame = 0;
            }

            this.styleOffset = `background-position: 0px -${240 * this.animatonFrame}px;`;
            (this.$scope as any).$ctrl.$element[0].style.cssText = this.styleText + this.styleOffset;
        });

        this.$scope.$watch("$ctrl.irHttpSrc", (alarmEvent: IEvent, oldAlarmEvent: IEvent, scope: IScope) => {
            if (alarmEvent) {
                const blob = this.getNoImageBlob();
                this.setupDefaultImage(scope, blob);

                const url = this.getThumbnailUrl(alarmEvent);
                this.$http
                    .get(url, {
                        cache: true,
                        headers: {
                            accept: "image/webp,image/*,*/*;q=0.8",
                        },
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        const imageblob = new Blob([response.data as any], { type: response.headers("Content-Type") });

                        this.setupBlobAttribute(imageblob);
                    })
                    .catch(() => {
                        // eslint-disable-next-line
                        console.log("Image not loaded!");
                    });
            }
        });
    }

    public $onDestroy() {
        this.timer.unsubscribe();
    }

    private init() {
        this.animatonFrame = 0;
        this.animatonPosition = 0;
        this.styleOffset = "";
    }

    private setupDefaultImage(scope: IScope, blob: Blob) {
        this.getThumbnailDefaultStyle(blob);
        this.styleText += "background-size: 320px 240px;";
        this.$element[0].style.cssText = this.styleText;
    }

    private setupBlobAttribute(blob: Blob) {
        this.getThumbnailDefaultStyle(blob);
        this.styleText += "background-size: cover;";
        this.$element.css(this.styleText + this.styleOffset);
    }

    private getThumbnailDefaultStyle(blob: Blob) {
        this.styleText = `height: 240px; width: 320px;
            background-image: url('${URL.createObjectURL(blob)}');`;
    }

    private getThumbnailUrl(alarmEvent: IEvent): string {
        return `${this.config.apiUrl}events/${alarmEvent.id}/image`;
    }

    private getNoImageBlob(): Blob {
        return new Blob([placeholder], { type: "image/svg+xml" });
    }
}
